import { alpha } from '@mui/material';
import { keyframes } from '@emotion/react';
import { bloxMarketingColors } from 'themes/constants';
import { useWidgetHashTarget } from './useWidgetHashTarget';

const pingAnimation = keyframes`
  0% {
    background-color: ${alpha(bloxMarketingColors.primary, 0.12)};
    box-shadow: 0 0 0 0px ${alpha(bloxMarketingColors.primary, 0.4)};
  }
  100% {
    background-color: ${alpha(bloxMarketingColors.primary, 0.04)};
    box-shadow: 0 0 0 8px ${alpha(bloxMarketingColors.primary, 0)};
  }
`;

export const ALERT_PULSE_ANIMATION = `${pingAnimation} 1s cubic-bezier(0,0,.2,1) infinite`;

/**
 * Returns whether the alert icon for the given widget should be pulsing.
 * Pulsing starts when the URL hash targets this widget (e.g. navigating from a
 * NotificationItem). It clears automatically when the user navigates away from
 * the dashboard or clicks a different widget alert (i.e. the hash changes).
 */
export const useWidgetAlertPulse = (widgetId: string): boolean => {
  return useWidgetHashTarget(widgetId);
};
